import { render, staticRenderFns } from "./huzhuNeed.vue?vue&type=template&id=772af660&scoped=true"
import script from "./huzhuNeed.vue?vue&type=script&lang=js"
export * from "./huzhuNeed.vue?vue&type=script&lang=js"
import style0 from "./huzhuNeed.vue?vue&type=style&index=0&id=772af660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772af660",
  null
  
)

export default component.exports